import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
/**
 * Label Optional Tag
 * This Styled Component is primarily here to be able to hide it in some circumstances.
 */
export const LabelOptionalTag = styled.span ``;
/**
 * Label
 */
export const labelContainerStyles = ({ theme, $colorContext, $disabled, }) => css `
	align-self: baseline;

	&&& {
		/* CORE-UI override */
		margin-top: 0;

		${$colorContext === 'on-light' &&
    css `
			color: ${theme.colors.base.textLabel};
		`}

		${$colorContext === 'on-medium' &&
    css `
			color: ${theme.colors.base.textLabel};
		`}

		${$colorContext === 'on-dark' &&
    css `
			color: ${theme.colors.blanc.textInverse};
		`}

		${$disabled &&
    css `
			color: ${theme.colors.medium.textInactive};
		`}
	}
`;
export const LabelContainer = styled(Typography).attrs({
    tagName: 'label',
    variant: 'label-title',
}) `
	${labelContainerStyles}
`;
